export default "__VITE_ASSET__DedeQ2gO__"